/* eslint-disable */
export class UpdateCustomerRequest {
    firstName!: string;
    lastName!: string;
    phone!: string;
    email!: string;
    locationAddress!: CustomerAddress;

    constructor(obj?: any) {
        if (!obj) {
            return;
        }
        this.firstName = obj.firstName;
        this.lastName = obj.lastName;
        this.phone = obj.phone;
        this.email = obj.email;
        this.locationAddress = new CustomerAddress(obj.locationAddress);
    }
}

export class CustomerAddress {
    address1!: string;
    address2!: string;
    cityId!: number;
    zipCode!: string;

    constructor(obj?: any) {
        if (!obj) {
            return;
        }
        this.address1 = obj.address1;
        this.address2 = obj.address2;
        this.cityId = obj.cityId;
        this.zipCode = obj.zipCode;
    }
}